import { ObjectUtils } from "~app/common/utils/object-utils";
import { IValidationRuleSettings } from "~app/common/validation/IValidationRuleSettings";
import { ValidationContext } from "~app/common/validation/validationContext";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ArbestorderDestineringsalternativViewModel } from "./arbetsorder-destineringsalternativ.models";

export class ArbetsorderDestineringsalternativValidation {
    static init(
        model: ArbestorderDestineringsalternativViewModel
    ): ValidationContext {
        const isWithinRange = (value: number): boolean => value >= 0 && value <= 100;

        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;

        const rules: IValidationRuleSettings[] = [];

        let destineringsalternativRuleCounter = 0;
        model.arbetsorderHandelssortiment.forEach((ahs) => {
            ahs.destineringsalternativ.forEach(dest => {
                rules.push({
                    id: `range_${destineringsalternativRuleCounter}`,
                    applicable: () => !ObjectUtils.isNullOrUndefined(dest.andel),
                    errorLevel: ValidationErrorLevels.error,
                    expression: (newValue: number) => isWithinRange(dest.andel),
                    message: {
                        text: "Måste vara mellan 0 och 100"
                    },
                    model: () => dest,
                    name: dest.ruleName,
                    triggerOnLoad: true
                });

                rules.push({
                    id: `sum_${destineringsalternativRuleCounter}`,
                    applicable: () => !ObjectUtils.isNullOrUndefined(dest.andel) && isWithinRange(dest.andel),
                    errorLevel: ValidationErrorLevels.error,
                    expression: () => {
                        const sum = ahs.destineringsalternativ
                        // eslint-disable-next-line sonarjs/no-nested-functions
                            .map((x) => x.andel)
                        // eslint-disable-next-line sonarjs/reduce-initial-value, sonarjs/no-nested-functions
                            .reduce((a, b) => a + b);
                        return sum <= 100;
                    },
                    message: {
                        text: "Destinering per handelssortiment får inte överstiga 100%"
                    },
                    model: () => dest,
                    name: dest.ruleName,
                    triggerOnLoad: true
                });

                destineringsalternativRuleCounter++;
            });
        });

        context.create(ValidationScopes.spara).withRules(rules);

        return context;
    }
}
